import React from 'react';

const EditUsers = () => {
  return <div></div>;
};
export default EditUsers;
